import type { RoomFeature } from '@brush/api-client';
import { Award, Sparkles, TrendingUp, type LucideIcon } from 'lucide-react';

/**
 * The room capabilities a template can be gated on, in the order the server normalises to — so
 * what comes back from a save reads in the same order it was chosen.
 *
 * Labels are the room's own words for these switches rather than the wire values, because the
 * thing being matched against is the room's feature list as an operator sees it.
 */
export const FEATURES: { value: RoomFeature; label: string; icon: LucideIcon }[] = [
  { value: 'leaderboard', label: 'Leaderboards', icon: Award },
  { value: 'fantasy', label: 'Fantasy competitions', icon: Sparkles },
  { value: 'ratings', label: 'Player ratings', icon: TrendingUp },
];

export const featureLabel = (value: string): string =>
  FEATURES.find((f) => f.value === value)?.label ?? value;
